/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IDivisionesTiposPropiedades from 'Infotrack@Modelos/smartStock/divisionesTiposPropiedades/entidades/divisionesTiposPropiedades';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IDivisionesTiposPropiedades>> => [
    {
        title: formatMessage({ id: 'divisionesTiposPropiedades.divisionTipoPropiedadDescripcion' }),
        field: 'DivisionTipoPropiedadDescripcion',
    },
    {
        title: formatMessage({ id: 'divisionesTiposPropiedades.propiedad' }),
        field: 'Propiedad',
    },
    {
        title: formatMessage({ id: 'productos.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (
        tipoFormulario: TipoFormulario,
        divisionesTiposPropiedades?: IDivisionesTiposPropiedades
    ) => void,
    cargarDivisionesTiposPropiedades: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (divisionesTiposPropiedades: IDivisionesTiposPropiedades) => void
): Array<Action<IDivisionesTiposPropiedades>> => [
    {
        icon: 'refresh',
        onClick: cargarDivisionesTiposPropiedades,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: 'add',
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon id="Icono-Editar" color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IDivisionesTiposPropiedades),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },

    {
        icon: () => <DeleteIcon id="Icono-Eliminar" color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IDivisionesTiposPropiedades),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IDivisionesTiposPropiedades> = {
    maxBodyHeight: '50vh',
};
